import React from 'react';
import { ACTIONABLE_BUTTON } from '../formats';
import DefaultFormatActionableButton from './DefaultFormatActionableButton';
import DefaultRootBody from './DefaultRootBody';
import DefaultRootHeader from './DefaultRootHeader';

const DefaultTypeObject = props => {
  // eslint-disable-next-line no-unused-vars
  const { children, schema, path = [], root: isRoot, isChildRoot } = props;
  const { $schema: isSchema, title, description, format } = schema;

  if (isSchema) {
    return (
      <div
        className={`${
          isSchema && !isChildRoot
            ? 'default-type-root'
            : isSchema && isChildRoot
            ? 'default-type-object is-child-root'
            : 'default-type-object'
        } depth-${path.length}`}
      >
        <DefaultRootHeader
          title={title}
          description={description}
          isChildRoot={isChildRoot}
        />
        <DefaultRootBody children={children} />
      </div>
    );
  }
  return (
    <div className={`default-type-object depth-${path.length}`}>
      {(title || description) && (
        <div className="default-type-object-title">
          <strong className="default-type-title">{title}</strong>
          {description && (
            <div className="default-type-description">{description}</div>
          )}
        </div>
      )}

      {format && format === ACTIONABLE_BUTTON && (
        <DefaultFormatActionableButton {...props} />
      )}

      <div className="default-type-object-children">{children}</div>
    </div>
  );
};

export default DefaultTypeObject;
